import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import Header from "./components/header";
import Landing from "./components/landing";
import About from "./components/about";
import WhyPage from "./components/whypage";
import BrandsPage from "./components/brandspage";
import Blogs from "./components/blog";
import Location from "./components/location";
import Footer from "./components/footer";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import BlogListPage from "./components/bloglistpage";
import BlogDetailedPage from './components/blogpage';

function PrivateRoute({ children }) {
  return localStorage.getItem("isAdmin") === "true" ? children : <Navigate to="/admin/login" />;
}

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="min-h-screen w-full overflow-x-hidden">
              <Header />
              <Landing />
              <About />
              <WhyPage />
              <BrandsPage />
              <Blogs />
              <Location/>
              <Footer />
            </div>
          }
        />
        <Route path="/adminlogin" element={<AdminLogin />} />
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <AdminDashboard />
            </PrivateRoute>
          }
        />
        {/* <Route path="/blogs" element={<BlogListPage />} /> */}
        <Route path="blog/:id" Component={BlogDetailedPage} />
      </Routes>
    </Router>
  );
}

export default App;
